<div class="dialog-content-wrapper" style="margin: -24px;">
    <mat-toolbar matDialogTitle class="mat-indigo-800-bg m-0 customBlue">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{translations.lblOrderForm}} {{ getLabel() }}</span>
            <span class="title dialog-title"></span>
            <button mat-button class="mat-icon-button" (click)="dialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>


    </mat-toolbar>

    <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar 
    style="max-height: 90vh;height: calc(90vh - 110px);padding-top: 0px !important">
    <mat-horizontal-stepper #stepper linear="true">
      
    
            <mat-step [completed]="false" >
                <ng-template matStepLabel>{{translations.lblOrder}}</ng-template>
                <app-order-detail [parent]="this" *ngIf="stepper.selectedIndex == 0"></app-order-detail>
            </mat-step>
            <mat-step [completed]="false" >
                <ng-template matStepLabel>{{translations.lblClient}}</ng-template>
                <app-customer-detail  [parent]="this" *ngIf="stepper.selectedIndex == 1"></app-customer-detail>
            </mat-step>
            <mat-step [completed]="false" >
                <ng-template matStepLabel>{{translations.lblDelivery}}</ng-template>
               
                <app-delivery-detail  [parent]="this" *ngIf="stepper.selectedIndex == 2"></app-delivery-detail>
            </mat-step>
            <mat-step [completed]="false">
                <ng-template matStepLabel>{{translations.lblPayment}}</ng-template>
                <app-payment-detail  [parent]="this" *ngIf="stepper.selectedIndex == 3"></app-payment-detail>
            </mat-step>
            <mat-step [completed]="false">
                <ng-template matStepLabel>{{translations.lblFinance}}</ng-template>
                <app-financial-detail  [parent]="this" *ngIf="stepper.selectedIndex == 4"></app-financial-detail>
            </mat-step>
            
        </mat-horizontal-stepper>
    </div>
    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="left" style="padding-bottom: 0px !important;padding-top:0px !important">
       
          <button mat-raised-button color="accent" aria-label="SAVE" fxFlex="50" (click)="goBack(stepper)" [disabled]="stepper.selectedIndex === 0">
            {{translations.btnPrevious}}
          </button>
      
          <button mat-raised-button color="accent" fxFlex="50"  (click)="goForward(stepper)" [disabled]="this.appService.invalidForm || stepper.selectedIndex === 4 ">
            {{translations.btnNext}}
          </button>


          <button mat-raised-button *ngIf="showSaveButton" color="accent" fxFlex="50"  (click)="save()" [disabled]="this.appService.invalidForm || disableSave" [style.display]="(stepper.selectedIndex === 4 || order.Id > 0) ? 'inherit' : 'none'">
            {{translations.btnSave}}
          </button>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/order/order-edit-form/order-edit-form.component.html